import i18next from 'i18next'
import * as React from 'react'
import { useInView } from '../../../../utils/hooks/hooks/useInView'
import { Link } from '../../../../utils/links'
import { InviewProps } from '../blocksState'

export type ActualitySearchBarProps = {
  index: number
  inview?: InviewProps
  query: string
  setQuery: (query: string) => void
}

export function ActualitySearchBarLayout(props: ActualitySearchBarProps) {
  const { inview } = props
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("ActualitySearchBarLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <section key={`block-${props.index}`} id={`io-${props.index}`} ref={ref} className={`block block--search-bar ${inView ? 'inview' : ''}`}>
      <div className="block__inner container--s spacing--m gutter--m">
        <header className="block__header">
          <h2 className="block__title title--m">
            {i18next.t('actualities:searchBarTitle')}
          </h2>
        </header>

        <div className="block__content">
          <div className="blockform blockform--search">
            <div className="blockform__inner">
              <label className="sr-text" htmlFor="a11y-c-search">
                {i18next.t('actualities:searchBarTitlePlaceHolder')}
              </label>
              <form>
                <input
                  className="blockform__input"
                  id="a11y-c-search"
                  name="c-search"
                  type="search"
                  value={props.query}
                  onChange={e => props.setQuery(e.target.value)}
                  placeholder={i18next.t('actualities:searchBarTitlePlaceHolder')}
                />
                <Link url={`/actualiteiten/zoeken?page=1&search=${props.query}`}>
                  <button
                    type="submit"
                    className="blockform__button button button--primary button--icon"
                  >
                    <span className="button__label">
                      {i18next.t('search:search')}
                    </span>
                    <svg className="button__icon" width="18px" height="18px">
                      <use xlinkHref="#icon--search" />
                    </svg>
                  </button>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

  )
}
